import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";

import {withStyles} from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Hidden from "@material-ui/core/Hidden";
import withWidth, {isWidthDown, isWidthUp} from '@material-ui/core/withWidth';

class SearchGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navToPage: null,
    };
  }

  renderDescrip(descrip) {
    if (!this.props.trending) {
      return (
        <Hidden mdDown implementation="css">
          <Typography variant="subheading" color="textSecondary">
            {descrip}
          </Typography>
        </Hidden>
      );
    }
  }

  renderSearchResults = () => this.props.searchData.map(qresult => {
    const {classes, history} = this.props;
    // TODO swap this with poll pals img as default
    const trump_img = "https://uploads-ssl.webflow.com/5b6dda309e9b6f542c3bda6d/5b6de85441c616e3796cd895_Asset%202trump.png";

    return (
      <GridListTile
        className={classes.gridTile}
        key={qresult.id}
        onClick={() => history.push(`/poll/${qresult.url_ext}`)}
      >
        <Card className={classes.card}>
          {/* <Hidden smDown implementation="css"> */}
            <CardMedia
              className={classes.pollImg}
              image={qresult.thumb_url.includes('http') ? qresult.thumb_url : trump_img}
              title={qresult.question}
            />
          {/* </Hidden> */}
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="headline">
                {qresult.question}
              </Typography>
              {this.renderDescrip(qresult.descrip)}
            </CardContent>
          </div>
        </Card>
      </GridListTile>
    );
  });

  render() {
    const {classes} = this.props;
    let gridListClass = classes.gridList;
    let numGridCols = 1;
    if (this.props.trending) {
      gridListClass = classes.gridListTrending;
      numGridCols = 2;
    }
    if (isWidthDown('sm', this.props.width)) {
      numGridCols = 1;
    }
    if (isWidthUp('xl', this.props.width)) {
      numGridCols = 3;
    }

    return (
      <div className={classes.root}>
        <GridList cols={numGridCols} className={gridListClass}>
          {this.renderSearchResults()}
        </GridList>
      </div>
    );
  }
}

SearchGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  root: {
    // display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    // backgroundColor: theme.palette.background.paper,
    backgroundColor: '#fff',
  },
  gridList: {
    maxHeight: 640,
    display: 'flex',
  },
  gridListTrending: {
    height: '100%',
    display: 'flex',
  },
  gridTile: {
    maxHeight: 184, // = to img height + grid padding
    "& > :first-child": {
      border: "1px solid #fff",
      transition: "all .2s",
    },
    "& > :first-child:hover": {
      transform: 'scale(1.05)',
      zIndex: 10,
      cursor: 'pointer',
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: 125, // = to img height + grid padding
    },
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  card: {
    display: 'flex',
    backgroundColor: '#ebebeb',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
    maxHeight: 151, // = to img height
    textAlign: 'left',
    overflowX: "hidden",
    textOverflow: "ellipse",
    "& h3": {
      fontSize: 14,
    },
    "& h1": {
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: 100, // = to img height
      "& h1": {
        fontSize: 16,
      },
    },
  },
  pollImg: {
    flexShrink: 0,
    width: 202,
    height: 151,
    [theme.breakpoints.down("sm")]: {
      width: 150,
      height: 100,
    },
  },
});

const searchGridComponent = withRouter(withStyles(styles)(SearchGrid));

export default withWidth()(searchGridComponent);



// WEBPACK FOOTER //
// ./src/components/SearchGrid/SearchGrid.jsx